import React from 'react'

const Jva_stIf = () => {
    return (
        <div className='container'>
            <td>


<h1 class="h1">Infix to Postfix Java</h1>
<p>The <strong>infix</strong> and <strong>postfix</strong> expressions can have the following operators: '+', '-',
      '%','*', '/' and alphabets from a to z. The precedence of the operators (+, -) is lesser than the precedence
      of operators (*, /, %). Parenthesis has the highest precedence and the expression inside it must be
      converted first. In this section, we will learn <strong>how to convert infix expression to postfix
            expression</strong> and <strong>postfix to infix expression through a Java program.</strong></p>
<p>For performing the conversion, we use <strong>Stack</strong> data structure. The
      stack is used to store the operators and parenthesis to enforce the precedence Start parsing the expression
      from left to right. Before moving ahead in this section, ensure that you are friendly with the
      <strong>stack</strong> and its operations. Let's have a look at <strong>infix</strong> and <strong>postfix
            expressions</strong>.</p>
<h2 class="h2">Infix Expression</h2>
<p>Infix expressions are those expressions in which the operator is written in-between the two or more operands.
      Usually, we use infix expression. For example, consider the following expression.</p>
<div class="containers">
      <div class="dp-highlighter">
            <div class="bar">
                  </div>
            <ul start="1" class="dp-j">
                  <li class="alt"><span><span>a+b&nbsp;&nbsp;</span></span></li>
                  <li class=""><span>a/<span class="number">2</span><span>+c*d-e*(f*g)&nbsp;&nbsp;</span></span>
                  </li>
                  <li class="alt"><span>a*(b+c)/d&nbsp;&nbsp;</span></li>
            </ul>
      </div>
</div>
<h2 class="h2">Postfix Expression</h2>
<p>Postfix expressions are those expressions in which the operator is written after their operands. For example,
      consider the following expression.</p>
<div class="containers">
      <div class="dp-highlighter">
            <div class="bar">
                  </div>
            <ul start="1" class="dp-j">
                  <li class="alt"><span><span>ab+&nbsp;&nbsp;</span></span></li>
                  <li class=""><span>abc/de+*+f-&nbsp;&nbsp;</span></li>
                  <li class="alt"><span>ab+cd-*&nbsp;&nbsp;</span></li>
            </ul>
      </div>
</div>
<h2 class="h2">Infix vs Postfix Expression</h2>
<table class="alt">
      <tbody>
            <tr>
                  <th>Infix Expression</th>
                  <th>Postfix Expression</th>
            </tr>
            <tr>
                  <td>A*B/C</td>
                  <td>AB*C/</td>
            </tr>
            <tr>
                  <td>(A/(B-C+D))*(E-A)*C</td>
                  <td>ABC-D+/EA-*C*</td>
            </tr>
            <tr>
                  <td>A/B-C+D*E-A*C</td>
                  <td>AB/C-DE*AC*-</td>
            </tr>
      </tbody>
</table>
<h2 class="h2">Infix to Postfix Conversion Example</h2>
<p>Convert the <strong>(X - Y / (Z + U) * V)</strong> infix expression into postfix expression.</p>
<table class="alt">
      <tbody>
            <tr>
                  <th>S.N.</th>
                  <th>Input</th>
                  <th>Operand Stack</th>
                  <th>Postfix Expression</th>
            </tr>
            <tr>
                  <td>1</td>
                  <td>(</td>
                  <td>(</td>
                  <td>-</td>
            </tr>
            <tr>
                  <td>2</td>
                  <td>X</td>
                  <td>(</td>
                  <td>X</td>
            </tr>
            <tr>
                  <td>3</td>
                  <td>-</td>
                  <td>( -</td>
                  <td>X</td>
            </tr>
            <tr>
                  <td>4</td>
                  <td>Y</td>
                  <td>( -</td>
                  <td>XY</td>
            </tr>
            <tr>
                  <td>5</td>
                  <td>/</td>
                  <td>( - /</td>
                  <td>XY</td>
            </tr>
            <tr>
                  <td>6</td>
                  <td>(</td>
                  <td>( - / (</td>
                  <td>XY</td>
            </tr>
            <tr>
                  <td>7</td>
                  <td>Z</td>
                  <td>( - / (</td>
                  <td>XYZ</td>
            </tr>
            <tr>
                  <td>8</td>
                  <td>+</td>
                  <td>( - / ( +</td>
                  <td>XYZ</td>
            </tr>
            <tr>
                  <td>9</td>
                  <td>U</td>
                  <td>( - / ( +</td>
                  <td>XYZU</td>
            </tr>
            <tr>
                  <td>10</td>
                  <td>)</td>
                  <td>( - /</td>
                  <td>XYZU+</td>
            </tr>
            <tr>
                  <td>11</td>
                  <td>*</td>
                  <td>( - *</td>
                  <td>XYZU+/</td>
            </tr>
            <tr>
                  <td>12</td>
                  <td>V</td>
                  <td>( - *</td>
                  <td>XYZU+/V</td>
            </tr>
            <tr>
                  <td>13</td>
                  <td>)</td>
                  <td>-</td>
                  <td>XYZU+/V*-</td>
            </tr>
      </tbody>
</table>
<h3 class="h3">Algorithm</h3>
<ul class="points">
      <li>Scan the infix notation from left to right one character at a time.</li>
      <li>If the next symbol scanned as an operand, append it to the postfix string.</li>
      <li>If the next symbol scanned as an operator, the:
            <ul class="points" type="i">
                  <li>Pop and append to the postfix string every operator on the stack that:
                        <ul class="pointsa">
                              <li>Is above the most recently scanned left parenthesis, and</li>
                              <li>Has precedence higher than or is a right-associative operator of equal
                                    precedence to that of the new operator symbol.</li>
                        </ul>
                  </li>
                  <li>Push the new operator onto the stack</li>
            </ul>
      </li>
      <li>If a left parenthesis is scanned, push it into the stack.</li>
      <li>If a right parenthesis is scanned, all operators down to the most recently scanned left parenthesis must
            be popped and appended to the postfix string. Furthermore, the pair of parentheses must be discarded.
      </li>
      <li>When the infix string is fully scanned, the stack may still contain some operators. All the remaining
            operators should be popped and appended to the postfix string.</li>
</ul>
<p>Let's implement the above algorithm in a Java program.</p>
<h3 class="h3">Java Program to Convert Infix Expression into Postfix Expression</h3>
<p><strong>InfixToPostfixConversion.java</strong></p>
<div class="containers">
      <div class="dp-highlighter">
            <div class="bar">
                  </div>
            <ul start="1" class="dp-j">
                  <li class="alt"><span><span
                                    class="keywords">import</span><span>&nbsp;java.io.*;&nbsp;&nbsp;</span></span>
                  </li>
                  <li class=""><span><span class="keywords">class</span><span>&nbsp;Stack&nbsp;&nbsp;</span></span>
                  </li>
                  <li class="alt"><span>&#123;&nbsp;&nbsp;</span></li>
                  <li class=""><span><span class="keywords">char</span><span>&nbsp;a[]=</span><span
                                    class="keywords">new</span><span>&nbsp;</span><span
                                    class="keywords">char</span><span>[</span><span
                                    class="number">100</span><span>];&nbsp;&nbsp;</span></span></li>
                  <li class="alt"><span><span class="keywords">int</span><span>&nbsp;top=-</span><span
                                    class="number">1</span><span>;&nbsp;&nbsp;</span></span></li>
                  <li class=""><span><span class="keywords">void</span><span>&nbsp;push(</span><span
                                    class="keywords">char</span><span>&nbsp;c)&nbsp;&nbsp;</span></span></li>
                  <li class="alt"><span>&#123;&nbsp;&nbsp;</span></li>
                  <li class=""><span><span class="keywords">try</span><span>&nbsp;&nbsp;</span></span></li>
                  <li class="alt"><span>&#123;&nbsp;&nbsp;</span></li>
                  <li class=""><span>a[++top]=&nbsp;c;&nbsp;&nbsp;</span></li>
                  <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
                  <li class=""><span><span
                                    class="keywords">catch</span><span>(StringIndexOutOfBoundsException&nbsp;e)&nbsp;&nbsp;</span></span>
                  </li>
                  <li class="alt"><span>&#123;&nbsp;&nbsp;</span></li>
                  <li class=""><span>System.out.println(<span
                                    class="plain">"Stack&nbsp;full,&nbsp;no&nbsp;room&nbsp;to&nbsp;push,&nbsp;size=100"</span><span>);&nbsp;&nbsp;</span></span>
                  </li>
                  <li class="alt"><span>System.exit(<span
                                    class="number">0</span><span>);&nbsp;&nbsp;</span></span></li>
                  <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
                  <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
                  <li class=""><span><span class="keywords">char</span><span>&nbsp;pop()&nbsp;&nbsp;</span></span>
                  </li>
                  <li class="alt"><span>&#123;&nbsp;&nbsp;</span></li>
                  <li class=""><span><span
                                    class="keywords">return</span><span>&nbsp;a[top--];&nbsp;&nbsp;</span></span>
                  </li>
                  <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
                  <li class=""><span><span
                                    class="keywords">boolean</span><span>&nbsp;isEmpty()&nbsp;&nbsp;</span></span>
                  </li>
                  <li class="alt"><span>&#123;&nbsp;&nbsp;</span></li>
                  <li class=""><span><span class="keywords">return</span><span>&nbsp;(top==-</span><span
                                    class="number">1</span><span>)?</span><span
                                    class="keywords">true</span><span>:</span><span
                                    class="keywords">false</span><span>;&nbsp;&nbsp;</span></span></li>
                  <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
                  <li class=""><span><span class="keywords">char</span><span>&nbsp;peek()&nbsp;&nbsp;</span></span>
                  </li>
                  <li class="alt"><span>&#123;&nbsp;&nbsp;</span></li>
                  <li class=""><span><span
                                    class="keywords">return</span><span>&nbsp;a[top];&nbsp;&nbsp;</span></span>
                  </li>
                  <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
                  <li class=""><span>&#125;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                  <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
                                    class="keywords">class</span><span>&nbsp;InfixToPostfix&nbsp;&nbsp;</span></span>
                  </li>
                  <li class=""><span>&#123;&nbsp;&nbsp;</span></li>
                  <li class="alt"><span><span
                                    class="keywords">static</span><span>&nbsp;Stack&nbsp;operators&nbsp;=&nbsp;</span><span
                                    class="keywords">new</span><span>&nbsp;Stack();&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                  </li>
                  <li class=""><span><span class="keywords">public</span><span>&nbsp;</span><span
                                    class="keywords">static</span><span>&nbsp;</span><span
                                    class="keywords">void</span><span>&nbsp;main(String&nbsp;argv[])&nbsp;</span><span
                                    class="keywords">throws</span><span>&nbsp;IOException&nbsp;&nbsp;</span></span>
                  </li>
                  <li class="alt"><span>&#123;&nbsp;&nbsp;</span></li>
                  <li class=""><span>String&nbsp;infix;&nbsp;&nbsp;</span></li>
                  <li class="alt"><span><span
                                    class="comment">//create&nbsp;an&nbsp;input&nbsp;stream&nbsp;object</span><span>&nbsp;&nbsp;</span></span>
                  </li>
                  <li class=""><span>BufferedReader&nbsp;keyboard&nbsp;=&nbsp;<span
                                    class="keywords">new</span><span>&nbsp;BufferedReader&nbsp;(</span><span
                                    class="keywords">new</span><span>&nbsp;InputStreamReader(System.in));&nbsp;&nbsp;</span></span>
                  </li>
                  <li class="alt"><span><span
                                    class="comment">//get&nbsp;input&nbsp;from&nbsp;user</span><span>&nbsp;&nbsp;</span></span>
                  </li>
                  <li class=""><span>System.out.print(<span
                                    class="plain">"\nEnter&nbsp;the&nbsp;infix&nbsp;expression&nbsp;you&nbsp;want&nbsp;to&nbsp;convert:&nbsp;"</span><span>);&nbsp;&nbsp;</span></span>
                  </li>
                  <li class="alt"><span>infix&nbsp;=&nbsp;keyboard.readLine();&nbsp;&nbsp;</span></li>
                  <li class=""><span><span
                                    class="comment">//output&nbsp;as&nbsp;postfix</span><span>&nbsp;&nbsp;</span></span>
                  </li>
                  <li class="alt"><span>System.out.println(<span
                                    class="plain">"Postfix&nbsp;expression&nbsp;for&nbsp;the&nbsp;given&nbsp;infix&nbsp;expression&nbsp;is:"</span><span>&nbsp;+&nbsp;toPostfix(infix));&nbsp;&nbsp;</span></span>
                  </li>
                  <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
                  <li class="alt"><span><span class="keywords">private</span><span>&nbsp;</span><span
                                    class="keywords">static</span><span>&nbsp;String&nbsp;toPostfix(String&nbsp;infix)&nbsp;&nbsp;</span></span>
                  </li>
                  <li class=""><span><span
                                    class="comment">//converts&nbsp;an&nbsp;infix&nbsp;expression&nbsp;to&nbsp;postfix</span><span>&nbsp;&nbsp;</span></span>
                  </li>
                  <li class="alt"><span>&#123;&nbsp;&nbsp;</span></li>
                  <li class=""><span><span
                                    class="keywords">char</span><span>&nbsp;symbol;&nbsp;&nbsp;</span></span></li>
                  <li class="alt"><span>String&nbsp;postfix&nbsp;=&nbsp;<span
                                    class="plain">""</span><span>;&nbsp;&nbsp;</span></span></li>
                  <li class=""><span><span class="keywords">for</span><span>(</span><span
                                    class="keywords">int</span><span>&nbsp;i=</span><span
                                    class="number">0</span><span>;i&lt;infix.length();++i)&nbsp;&nbsp;</span></span>
                  </li>
                  <li class="alt"><span><span
                                    class="comment">//while&nbsp;there&nbsp;is&nbsp;input&nbsp;to&nbsp;be&nbsp;read</span><span>&nbsp;&nbsp;</span></span>
                  </li>
                  <li class=""><span>&#123;&nbsp;&nbsp;</span></li>
                  <li class="alt"><span>symbol&nbsp;=&nbsp;infix.charAt(i);&nbsp;&nbsp;</span></li>
                  <li class=""><span><span
                                    class="comment">//if&nbsp;it's&nbsp;an&nbsp;operand,&nbsp;add&nbsp;it&nbsp;to&nbsp;the&nbsp;string</span><span>&nbsp;&nbsp;</span></span>
                  </li>
                  <li class="alt"><span><span
                                    class="keywords">if</span><span>&nbsp;(Character.isLetter(symbol))&nbsp;&nbsp;</span></span>
                  </li>
                  <li class=""><span>postfix&nbsp;=&nbsp;postfix&nbsp;+&nbsp;symbol;&nbsp;&nbsp;</span></li>
                  <li class="alt"><span><span class="keywords">else</span><span>&nbsp;</span><span
                                    class="keywords">if</span><span>&nbsp;(symbol==</span><span
                                    class="plain">'('</span><span>)&nbsp;&nbsp;</span></span></li>
                  <li class=""><span><span class="comment">//push&nbsp;(</span><span>&nbsp;&nbsp;</span></span>
                  </li>
                  <li class="alt"><span>&#123;&nbsp;&nbsp;</span></li>
                  <li class=""><span>operators.push(symbol);&nbsp;&nbsp;</span></li>
                  <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
                  <li class=""><span><span class="keywords">else</span><span>&nbsp;</span><span
                                    class="keywords">if</span><span>&nbsp;(symbol==</span><span
                                    class="plain">')'</span><span>)&nbsp;&nbsp;</span></span></li>
                  <li class="alt"><span><span
                                    class="comment">//push&nbsp;everything&nbsp;back&nbsp;to&nbsp;(</span><span>&nbsp;&nbsp;</span></span>
                  </li>
                  <li class=""><span>&#123;&nbsp;&nbsp;</span></li>
                  <li class="alt"><span><span
                                    class="keywords">while</span><span>&nbsp;(operators.peek()&nbsp;!=&nbsp;</span><span
                                    class="plain">'('</span><span>)&nbsp;&nbsp;</span></span></li>
                  <li class=""><span>&#123;&nbsp;&nbsp;</span></li>
                  <li class="alt">
                        <span>postfix&nbsp;=&nbsp;postfix&nbsp;+&nbsp;operators.pop();&nbsp;&nbsp;</span></li>
                  <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
                  <li class="alt"><span>operators.pop();&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                    class="comment">//remove&nbsp;'('</span><span>&nbsp;&nbsp;</span></span></li>
                  <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
                  <li class="alt"><span><span class="keywords">else</span><span>&nbsp;&nbsp;</span></span></li>
                  <li class=""><span><span
                                    class="comment">//print&nbsp;operators&nbsp;occurring&nbsp;before&nbsp;it&nbsp;that&nbsp;have&nbsp;greater&nbsp;precedence</span><span>&nbsp;&nbsp;</span></span>
                  </li>
                  <li class="alt"><span>&#123;&nbsp;&nbsp;</span></li>
                  <li class=""><span><span
                                    class="keywords">while</span><span>&nbsp;(!operators.isEmpty()&nbsp;&amp;&amp;&nbsp;!(operators.peek()==</span><span
                                    class="plain">'('</span><span>)&nbsp;&amp;&amp;&nbsp;prec(symbol)&nbsp;&lt;=&nbsp;prec(operators.peek()))&nbsp;&nbsp;</span></span>
                  </li>
                  <li class="alt">
                        <span>postfix&nbsp;=&nbsp;postfix&nbsp;+&nbsp;operators.pop();&nbsp;&nbsp;</span></li>
                  <li class=""><span>operators.push(symbol);&nbsp;&nbsp;</span></li>
                  <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
                  <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
                  <li class="alt"><span><span
                                    class="keywords">while</span><span>&nbsp;(!operators.isEmpty())&nbsp;&nbsp;</span></span>
                  </li>
                  <li class=""><span>postfix&nbsp;=&nbsp;postfix&nbsp;+&nbsp;operators.pop();&nbsp;&nbsp;</span>
                  </li>
                  <li class="alt"><span><span
                                    class="keywords">return</span><span>&nbsp;postfix;&nbsp;&nbsp;</span></span>
                  </li>
                  <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
                  <li class="alt"><span><span class="keywords">static</span><span>&nbsp;</span><span
                                    class="keywords">int</span><span>&nbsp;prec(</span><span
                                    class="keywords">char</span><span>&nbsp;x)&nbsp;&nbsp;</span></span></li>
                  <li class=""><span>&#123;&nbsp;&nbsp;</span></li>
                  <li class="alt"><span><span class="keywords">if</span><span>&nbsp;(x&nbsp;==&nbsp;</span><span
                                    class="plain">'+'</span><span>&nbsp;||&nbsp;x&nbsp;==&nbsp;</span><span
                                    class="plain">'-'</span><span>)&nbsp;&nbsp;</span></span></li>
                  <li class=""><span><span class="keywords">return</span><span>&nbsp;</span><span
                                    class="number">1</span><span>;&nbsp;&nbsp;</span></span></li>
                  <li class="alt"><span><span class="keywords">if</span><span>&nbsp;(x&nbsp;==&nbsp;</span><span
                                    class="plain">'*'</span><span>&nbsp;||&nbsp;x&nbsp;==&nbsp;</span><span
                                    class="plain">'/'</span><span>&nbsp;||&nbsp;x&nbsp;==&nbsp;</span><span
                                    class="plain">'%'</span><span>)&nbsp;&nbsp;</span></span></li>
                  <li class=""><span><span class="keywords">return</span><span>&nbsp;</span><span
                                    class="number">2</span><span>;&nbsp;&nbsp;</span></span></li>
                  <li class="alt"><span><span class="keywords">return</span><span>&nbsp;</span><span
                                    class="number">0</span><span>;&nbsp;&nbsp;</span></span></li>
                  <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
                  <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
            </ul>
      </div>
</div>
<h2 class="h2">Postfix to Infix Conversion Example</h2>
<p>Convert the <strong>AB + CD - /</strong> postfix expression into infix expression.</p>
<table class="points">
      <tbody>
            <tr>
                  <th>S.N.</th>
                  <th>Input</th>
                  <th>Operand Stack</th>
                  <th>Infix Expression</th>
            </tr>
            <tr>
                  <td>1</td>
                  <td>A</td>
                  <td>A</td>
                  <td>-</td>
            </tr>
            <tr>
                  <td>2</td>
                  <td>B</td>
                  <td>A, B</td>
                  <td>-</td>
            </tr>
            <tr>
                  <td>3</td>
                  <td>+</td>
                  <td>A + B</td>
                  <td>A+ B</td>
            </tr>
            <tr>
                  <td>4</td>
                  <td>C</td>
                  <td>A + B, C</td>
                  <td>-</td>
            </tr>
            <tr>
                  <td>5</td>
                  <td>D</td>
                  <td>A + B, C, D</td>
                  <td>-</td>
            </tr>
            <tr>
                  <td>6</td>
                  <td>-</td>
                  <td>A + B, C - D</td>
                  <td>C - D</td>
            </tr>
            <tr>
                  <td>7</td>
                  <td>/</td>
                  <td>A + B / C - D</td>
                  <td>A + B / C - D</td>
            </tr>
      </tbody>
</table>
<h3 class="h3">Algorithm</h3>
<ul class="points">
      <li>Read the postfix expression from left to right one character at a time.</li>
      <li>If it is operand push into operand stack.</li>
      <li>If it is an operator, then:
            <ul class="points" type="i">
                  <li>Pop two operand from the stack.</li>
                  <li>From infix expression and push into the operand stack</li>
            </ul>
      </li>
      <li>If the expression is not ended go to the first step.</li>
      <li>Pop operand stack and display.</li>
      <li>Exit</li>
</ul>
<p>Let's implement the above algorithm in a Java program.</p>
<h3 class="h3">Java Program to Convert Postfix Expression into Infix Expression</h3>
<p><strong>PostfixToInfixConversion.java</strong></p>
<div class="containers">
      <div class="dp-highlighter">
            <div class="bar">
                  </div>
            <ul start="1" class="dp-j">
                  <li class="alt"><span><span
                                    class="keywords">import</span><span>&nbsp;java.util.Scanner;&nbsp;&nbsp;</span></span>
                  </li>
                  <li class=""><span><span
                                    class="keywords">import</span><span>&nbsp;java.util.Stack;&nbsp;&nbsp;</span></span>
                  </li>
                  <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
                                    class="keywords">class</span><span>&nbsp;PostfixToInfixConversion&nbsp;&nbsp;</span></span>
                  </li>
                  <li class=""><span>&#123;&nbsp;&nbsp;</span></li>
                  <li class="alt"><span><span
                                    class="comment">//user-defined&nbsp;function&nbsp;that&nbsp;checks&nbsp;the&nbsp;character&nbsp;is&nbsp;operator&nbsp;or&nbsp;not&nbsp;&nbsp;&nbsp;&nbsp;</span><span>&nbsp;&nbsp;</span></span>
                  </li>
                  <li class=""><span><span class="keywords">private</span><span>&nbsp;</span><span
                                    class="keywords">boolean</span><span>&nbsp;isOperator(</span><span
                                    class="keywords">char</span><span>&nbsp;ch)&nbsp;&nbsp;&nbsp;</span></span>
                  </li>
                  <li class="alt"><span>&#123;&nbsp;&nbsp;</span></li>
                  <li class=""><span><span class="keywords">if</span><span>&nbsp;(ch&nbsp;==&nbsp;</span><span
                                    class="plain">'+'</span><span>&nbsp;||&nbsp;ch&nbsp;==&nbsp;</span><span
                                    class="plain">'-'</span><span>&nbsp;||&nbsp;ch&nbsp;==&nbsp;</span><span
                                    class="plain">'*'</span><span>&nbsp;||&nbsp;ch&nbsp;==&nbsp;</span><span
                                    class="plain">'/'</span><span>&nbsp;||&nbsp;ch&nbsp;==&nbsp;</span><span
                                    class="plain">'^'</span><span>)&nbsp;&nbsp;</span></span></li>
                  <li class="alt"><span><span
                                    class="comment">//returns&nbsp;true&nbsp;if&nbsp;either&nbsp;of&nbsp;the&nbsp;operator&nbsp;is&nbsp;found</span><span>&nbsp;&nbsp;</span></span>
                  </li>
                  <li class=""><span><span class="keywords">return</span><span>&nbsp;</span><span
                                    class="keywords">true</span><span>;&nbsp;&nbsp;</span></span></li>
                  <li class="alt"><span><span
                                    class="comment">//else&nbsp;returns&nbsp;false</span><span>&nbsp;&nbsp;</span></span>
                  </li>
                  <li class=""><span><span class="keywords">return</span><span>&nbsp;</span><span
                                    class="keywords">false</span><span>;&nbsp;&nbsp;</span></span></li>
                  <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
                  <li class=""><span><span
                                    class="comment">//user-defined&nbsp;function&nbsp;that&nbsp;performs&nbsp;conversion</span><span>&nbsp;&nbsp;</span></span>
                  </li>
                  <li class="alt"><span><span
                                    class="keywords">public</span><span>&nbsp;String&nbsp;convertPostfixToInfix(String&nbsp;postfixstring)&nbsp;&nbsp;&nbsp;</span></span>
                  </li>
                  <li class=""><span>&#123;&nbsp;&nbsp;</span></li>
                  <li class="alt"><span><span
                                    class="comment">//implementing&nbsp;stack&nbsp;&nbsp;&nbsp;&nbsp;</span><span>&nbsp;&nbsp;</span></span>
                  </li>
                  <li class=""><span>Stack&lt;String&gt;&nbsp;s&nbsp;=&nbsp;<span
                                    class="keywords">new</span><span>&nbsp;Stack&lt;&gt;();&nbsp;&nbsp;</span></span>
                  </li>
                  <li class="alt"><span><span
                                    class="comment">//iterates&nbsp;over&nbsp;the&nbsp;postfix&nbsp;expression</span><span>&nbsp;&nbsp;</span></span>
                  </li>
                  <li class=""><span><span class="keywords">for</span><span>&nbsp;(</span><span
                                    class="keywords">int</span><span>&nbsp;i&nbsp;=&nbsp;</span><span
                                    class="number">0</span><span>;&nbsp;i&nbsp;&lt;&nbsp;postfixstring.length();&nbsp;i++)&nbsp;&nbsp;&nbsp;</span></span>
                  </li>
                  <li class="alt"><span>&#123;&nbsp;&nbsp;</span></li>
                  <li class=""><span><span
                                    class="comment">//reading&nbsp;a&nbsp;character&nbsp;at&nbsp;a&nbsp;time&nbsp;&nbsp;&nbsp;&nbsp;</span><span>&nbsp;&nbsp;</span></span>
                  </li>
                  <li class="alt"><span><span
                                    class="keywords">char</span><span>&nbsp;ch&nbsp;=&nbsp;postfixstring.charAt(i);&nbsp;&nbsp;</span></span>
                  </li>
                  <li class=""><span><span
                                    class="comment">//inside&nbsp;the&nbsp;if-statement&nbsp;we&nbsp;have&nbsp;called&nbsp;the&nbsp;user-defined&nbsp;function&nbsp;that&nbsp;checks&nbsp;whether&nbsp;the&nbsp;character&nbsp;is&nbsp;operator&nbsp;or&nbsp;not</span><span>&nbsp;&nbsp;</span></span>
                  </li>
                  <li class="alt"><span><span
                                    class="keywords">if</span><span>&nbsp;(isOperator(ch))&nbsp;&nbsp;&nbsp;</span></span>
                  </li>
                  <li class=""><span>&#123;&nbsp;&nbsp;</span></li>
                  <li class="alt"><span>String&nbsp;b&nbsp;=&nbsp;s.pop();&nbsp;&nbsp;</span></li>
                  <li class=""><span>String&nbsp;a&nbsp;=&nbsp;s.pop();&nbsp;&nbsp;</span></li>
                  <li class="alt"><span><span
                                    class="comment">//push&nbsp;the&nbsp;character&nbsp;(operator)&nbsp;into&nbsp;stack&nbsp;in&nbsp;between&nbsp;the&nbsp;string&nbsp;a&nbsp;and&nbsp;b</span><span>&nbsp;&nbsp;</span></span>
                  </li>
                  <li class=""><span>s.push(<span
                                    class="plain">"("</span><span>&nbsp;+&nbsp;a&nbsp;+&nbsp;ch&nbsp;+&nbsp;b&nbsp;+&nbsp;</span><span
                                    class="plain">")"</span><span>);&nbsp;&nbsp;</span></span></li>
                  <li class="alt"><span>&#125;&nbsp;&nbsp;&nbsp;</span></li>
                  <li class=""><span><span class="keywords">else</span><span>&nbsp;&nbsp;</span></span></li>
                  <li class="alt"><span><span
                                    class="comment">//push&nbsp;character&nbsp;into&nbsp;the&nbsp;stack</span><span>&nbsp;&nbsp;</span></span>
                  </li>
                  <li class=""><span>s.push(<span
                                    class="plain">""</span><span>&nbsp;+&nbsp;ch);&nbsp;&nbsp;</span></span></li>
                  <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
                  <li class=""><span><span
                                    class="comment">//pop&nbsp;character&nbsp;from&nbsp;the&nbsp;stack&nbsp;and&nbsp;returns&nbsp;the&nbsp;same</span><span>&nbsp;&nbsp;</span></span>
                  </li>
                  <li class="alt"><span><span
                                    class="keywords">return</span><span>&nbsp;s.pop();&nbsp;&nbsp;</span></span>
                  </li>
                  <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
                  <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
                                    class="keywords">static</span><span>&nbsp;</span><span
                                    class="keywords">void</span><span>&nbsp;main(String&nbsp;args[])&nbsp;&nbsp;&nbsp;</span></span>
                  </li>
                  <li class=""><span>&#123;&nbsp;&nbsp;</span></li>
                  <li class="alt"><span><span
                                    class="comment">//creating&nbsp;object&nbsp;of&nbsp;the&nbsp;class</span><span>&nbsp;&nbsp;</span></span>
                  </li>
                  <li class=""><span>PostfixToInfixConversion&nbsp;obj&nbsp;=&nbsp;<span
                                    class="keywords">new</span><span>&nbsp;PostfixToInfixConversion();&nbsp;&nbsp;</span></span>
                  </li>
                  <li class="alt"><span>Scanner&nbsp;sc&nbsp;=&nbsp;<span
                                    class="keywords">new</span><span>&nbsp;Scanner(System.in);&nbsp;&nbsp;</span></span>
                  </li>
                  <li class=""><span>System.out.print(<span
                                    class="plain">"Enter&nbsp;the&nbsp;postfix&nbsp;expression&nbsp;you&nbsp;want&nbsp;to&nbsp;convert:&nbsp;"</span><span>);&nbsp;&nbsp;</span></span>
                  </li>
                  <li class="alt"><span><span
                                    class="comment">//reads&nbsp;a&nbsp;postfix&nbsp;expression&nbsp;from&nbsp;the&nbsp;user</span><span>&nbsp;&nbsp;</span></span>
                  </li>
                  <li class=""><span>String&nbsp;postfixstring&nbsp;=&nbsp;sc.next();&nbsp;<span
                                    class="comment">//for&nbsp;example&nbsp;ab+</span><span>&nbsp;&nbsp;</span></span>
                  </li>
                  <li class="alt"><span><span
                                    class="comment">//prints&nbsp;the&nbsp;infix&nbsp;expression</span><span>&nbsp;&nbsp;</span></span>
                  </li>
                  <li class=""><span>System.out.println(<span
                                    class="plain">"Infix&nbsp;expression&nbsp;for&nbsp;the&nbsp;given&nbsp;postfix&nbsp;expression&nbsp;is:&nbsp;"</span><span>&nbsp;+&nbsp;obj.convertPostfixToInfix(postfixstring));&nbsp;&nbsp;</span></span>
                  </li>
                  <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
                  <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
            </ul>
      </div>
</div>

</td>
        </div>
    )
}

export default Jva_stIf
